export default "__VITE_ASSET__C0xVTt0Q__"